import { render } from "./ProcurePageCard.vue?vue&type=template&id=5ce6aaab&scoped=true"
import script from "./ProcurePageCard.vue?vue&type=script&lang=js"
export * from "./ProcurePageCard.vue?vue&type=script&lang=js"

import "./ProcurePageCard.vue?vue&type=style&index=0&id=5ce6aaab&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce6aaab"]])

export default __exports__